import {Component, OnInit} from "@angular/core";
import {FUIChromeControlsService} from "./chrome-controls.service";

@Component({
    providers: [FUIChromeControlsService],
    selector: "fui-chrome-controls",
    templateUrl: "./chrome-controls.component.html",
    styleUrls: ["./chrome-controls.component.scss"]
})
export class FUIChromeControlsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
